import React from "react";
import { BiteData } from "../../types/data";
import Bite from "../scrollable/Bite";
import Item from "../scrollable/Item";
import TooltipWrapper from "../TooltipWrapper";
import { CaretPosition } from "../../../../types/ui";
import BiteOverview from "../scrollable/BiteOverview";
import { BiteStatus } from "../../types/enums";

interface ScrollableListProps {
  bites: BiteData[];
  name: string;
  lessonName?: string;
}

const ScrollableList: React.FC<ScrollableListProps> = ({
  bites,
  name,
  lessonName,
}) => {
  const shouldShowTooltip = (bite: BiteData) => {
    // Show tooltip for bites that have been started (completed or incomplete)
    // Don't show for not_started bites
    return (
      bite.biteStatus === BiteStatus.COMPLETED ||
      bite.biteStatus === BiteStatus.INCOMPLETE ||
      bite.isLastLearned ||
      bite.attempts.length > 0
    );
  };

  return (
    <div className="et-analytics-bites flex flex-wrap w-full justify-start items-center">
      {bites.length === 0 && (
        <>
          <span aria-hidden="true">—</span>
          <span className="sr-only">No content bites</span>
        </>
      )}
      {bites.map((bite) => (
        <Item key={bite.biteId} width={25} height={32}>
          {shouldShowTooltip(bite) ? (
            <TooltipWrapper
              ariaLabel={`${name}: bite ${bite.biteIndex} of ${lessonName || "lesson"}`}
              trigger={<Bite bite={bite} showTitle={false} />}
              tooltip={
                <BiteOverview
                  bite={bite}
                  bites={bites}
                  name={name}
                  lessonName={lessonName}
                />
              }
              caret={{ position: CaretPosition.BOTTOM, color: "#DCDCDC" }}
              width="auto"
              tooltipClassName="!p-5 !rounded-[20px]"
              wrapperClassName="w-full h-full"
              lazyRender
            />
          ) : (
            <div className="w-full h-full">
              <Bite bite={bite} />
            </div>
          )}
        </Item>
      ))}
    </div>
  );
};

export default ScrollableList;
